import React, { useContext, useState } from 'react';
import { useHistory } from 'react-router-dom';

import MUIDataTable from "mui-datatables";
import { Box, Tooltip, Typography, Chip, IconButton } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileInvoice } from '@fortawesome/free-solid-svg-icons';
import UserContext from '../../../navigation/context/userContext';

export default function OrdersDataTable(props) {
    const { userData } = useContext(UserContext);
    const [orders, setOrders] = useState(props.orders);

    const history = useHistory();
    
    const redirect = (route) => {
        history.push(route);
    };

    // --- DICCIONARIO VISUAL DE ESTATUS ---
    const getStatusChip = (status) => {
        let bgcolor = '#f5f5f5';
        let textcolor = '#333';

        switch (status) {
            case 'Finalizado':
            case 'Entregado':
                bgcolor = '#e8f5e9'; textcolor = '#2e7d32'; // Verde
                break;
            case 'Aprobado':
            case 'Enviado':
                bgcolor = '#e3f2fd'; textcolor = '#1565c0'; // Azul
                break;
            case 'Solicitado':
            case 'Por enviar':
                bgcolor = '#fff3e0'; textcolor = '#ed6c02'; // Naranja
                break;
            case 'Rechazado':
            case 'Cancelado':
                bgcolor = '#ffebee'; textcolor = '#c62828'; // Rojo
                break;
            default:
                bgcolor = '#f5f5f5'; textcolor = '#666';
        }

        return (
            <Chip 
                label={status} 
                size="small" 
                sx={{ bgcolor, color: textcolor, fontWeight: 'bold', borderRadius: 2 }} 
            />
        );
    };

    const columns = [
        {
            name: 'orderID',
            label: '#',
            options: {
                filter: false,
                customBodyRender: (value) => (
                    <Typography variant="body2" fontWeight="bold" color="text.secondary">
                        {value}
                    </Typography>
                )
            }
        },
        {
            name: 'cliente',
            label: 'Cliente',
            options: {
                filter: false,
                customBodyRenderLite: (dataIndex) => (
                    <Box>
                        <Typography variant="subtitle2" fontWeight="bold" color="text.primary">
                            {orders[dataIndex].cliente}
                        </Typography>
                        <Typography variant="caption" color="text.secondary">
                            {orders[dataIndex].created_at}
                        </Typography>
                    </Box>
                )
            }
        },
        {
            name: 'codigo',
            label: 'Código',
            options: {
                filter: false,
                customBodyRender: (value) => (
                    <Typography 
                        variant="body2" 
                        sx={{ 
                            fontFamily: 'monospace', fontWeight: 600, color: '#444',
                            bgcolor: '#f4f6f8', px: 1, py: 0.5, borderRadius: 1, display: 'inline-block' 
                        }}
                    >
                        {value}
                    </Typography>
                )
            }
        },
        {
            name: 'tipo_pedido',
            label: 'Categoría',
            options: {
                filter: true,
                customBodyRender: (value) => value ? (
                    <Typography variant="body2" color="text.secondary" fontWeight="500">
                        {value}
                    </Typography>
                ) : '-'
            }
        },
        {
            name: 'tipo_entrega',
            label: 'Entrega',
            options: {
                filter: true,
                customBodyRender: (value) => value ? (
                     <Typography variant="body2" color="text.secondary">{value}</Typography>
                ) : '-'
            }
        },
        {
            name: 'delivery',
            label: 'Modalidad',
            options: {
                filter: true,
                customBodyRender: (value) => value ? (
                     <Typography variant="body2" color="text.secondary">{value}</Typography>
                ) : '-'
            }
        },
        {
            name: 'monto',
            label: 'Monto',
            options: {
                filter: false,
                customBodyRenderLite: (dataIndex) => (
                    <Typography variant="subtitle2" fontWeight="bold" color="primary.main" textAlign="right">
                        ${orders[dataIndex].monto}
                    </Typography>
                )
            }
        },
        {
            name: 'estatus',
            label: 'Estatus',
            options: {
                filter: true,
                customBodyRender: (value) => getStatusChip(value)
            }
        },
        {
            name: 'acciones',
            label: 'Acciones',
            options: {
                filter: false,
                sort: false,
                customBodyRenderLite: (dataIndex) => (
                    <Box display="flex" justifyContent="center">
                        <Tooltip title='Ver Detalles'>
                            <IconButton 
                                onClick={() => redirect('/orders/details/' + orders[dataIndex].codigo)}
                                sx={{ 
                                    bgcolor: 'rgba(0, 118, 255, 0.05)', 
                                    color: 'primary.main', 
                                    '&:hover': { bgcolor: 'rgba(0, 118, 255, 0.15)' } 
                                }}
                                size="small"
                            >
                                <FontAwesomeIcon icon={faFileInvoice} />
                            </IconButton>
                        </Tooltip>
                    </Box>
                )
            }
        }
    ];

    const options = {
        filterType: 'checkbox',
        selectableRows: 'none',
        elevation: 0, // Quitamos la sombra nativa
        searchPlaceholder: 'Buscar pedido...',
        // Traducción de los controles de la tabla
        textLabels: {
            body: { noMatch: "No se encontraron pedidos", toolTip: "Ordenar" },
            pagination: { next: "Siguiente página", previous: "Página anterior", rowsPerPage: "Filas por página:", displayRows: "de" },
            toolbar: { search: "Buscar", downloadCsv: "Descargar CSV", print: "Imprimir", viewColumns: "Ver Columnas", filterTable: "Filtrar" },
            filter: { all: "Todos", title: "FILTROS", reset: "RESTABLECER" },
            viewColumns: { title: "Mostrar Columnas", titleAria: "Mostrar/Ocultar Columnas" },
        }
    };

    return (
        // Envolvemos la tabla en un Box con bordes para que combine con los KPIs
        <Box sx={{ border: '1px solid #e0e0e0', borderRadius: 4, overflow: 'hidden', bgcolor: '#fff' }}>
            <MUIDataTable
                title={<Typography variant="h6" fontWeight="bold" sx={{ color: '#222' }}>Listado de Pedidos</Typography>}
                data={orders}
                columns={columns}
                options={options}
            />
        </Box>
    );
}